
export default function guest({ next , store}) {

  if (!store.getters['auth/isAuth']) {
    next();
  } else {
    next('/');
  }
}
